import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { ProgressButton } from 'components';
import ContainerDirectorySettingsForm from 'components/DirectorySettingsForm/ContainerDirectorySettingsForm';

const DirectorySettingsDialog = ({ formOpen, toggleForm, handleChange, handleSave, isLoading }) => {
	return (
		<Dialog
			maxWidth={'md'}
			fullWidth={true}
			open={formOpen}
			onClose={toggleForm}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">Directory Settings</DialogTitle>
			<DialogContent>
				Select the fields you would like to display in the Member Directory.
				<DialogContentText id="alert-dialog-description">
					<ContainerDirectorySettingsForm handleChange={handleChange} />
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" color="inherit" onClick={toggleForm}>
					Cancel
				</Button>
				<ProgressButton
					circleColor="secondary"
					button={
						<Button onClick={handleSave} variant="contained" color="primary" autoFocus>
							Save
						</Button>
					}
					isLoading={isLoading}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default DirectorySettingsDialog;
